// extracted by mini-css-extract-plugin
export default {"container":"styles_container__ViDsH","image":"styles_image__BQXdy","hints":"styles_hints__9vF+9","action":"styles_action__ap0r2"};